export default __webpack_public_path__ + "static/media/logo-rv-point.c3dc4955.svg";